import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const MenuBulletHorizontal = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Normal / Menu-3-Hor" clipPath="url(#clip0_3001_4902)">
        <mask
          id="mask0_3001_4902"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect id="Bounding box" width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_3001_4902)">
          <path
            id="Menu-3-Hor"
            d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10ZM2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.89543 6 0 6.89543 0 8C0 9.10457 0.89543 10 2 10ZM14 10C15.1046 10 16 9.10457 16 8C16 6.89543 15.1046 6 14 6C12.8954 6 12 6.89543 12 8C12 9.10457 12.8954 10 14 10Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3001_4902">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </svg>
  );
};

MenuBulletHorizontal.displayName = 'MenuBulletHorizontal';
